<template>
    <div>
        <form @submit.prevent="submitInfo">
            <div class="row">
                <div class="col-12 col-lg">
                    <div class="form-group">
                        <label class="form-label">Page Header</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="headerTitle">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Description
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="headerDescription">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Appointment Section</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="appointmentTitle">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Description
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="appointmentDescription">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Contact Section</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="contactShop">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Description
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="contactDescription">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Address
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="contactAddress">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Email
                                </span>
                            </div>
                            <input required type="email" class="form-control bg-transparent pl-3" v-model="contactEmail" @keyup="emailValidation">
                        </div>
                        <div v-if="emailError" class="error-validation">{{ emailError }}</div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Contact
                                </span>
                            </div>
                            <input required type="tel" class="form-control bg-transparent pl-3" v-model="contactContact" @keyup="contactValidation">
                        </div>
                        <div v-if="contactError" class="error-validation">{{ contactError }}</div>
                    </div>
                </div>
                <div class="d-none d-lg-block col-auto border-right"></div>
                <div class="d-none d-lg-block col-auto"></div>
                <div class="col-12 col-lg mt-3 mt-lg-0">
                    <div class="form-group">
                        <label class="form-label">Reward QR Section</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="rewardQRTitle">
                        </div>
                        <!-- <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Body
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="rewardQRBody">
                        </div> -->
                    </div>
                    <div class="form-group">
                        <label class="form-label">Gallery Section</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="galleryTitle">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Description
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="galleryDescription">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Team Section</label>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Title
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="teamTitle">
                        </div>
                        <div class="input-group bg-white shadow-inset-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                    Description
                                </span>
                            </div>
                            <input required type="text" class="form-control bg-transparent pl-3" v-model="teamDescription">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Page Color</label>
                        <div class="row">
                            <div class="col-4">
                                <div class="input-group bg-white shadow-inset-2 mb-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                            Primary
                                        </span>
                                    </div>
                                    <button id="popover-color-primary" type="button" class="form-control pl-3" :style="{ 'background-color': (primary || {}).hex  }"></button>
                                </div>
                                <b-popover
                                    ref="popover-color"
                                    target="popover-color-primary"
                                    triggers="click blur"
                                    boundary="window"
                                    placement="righttop">
                                    <sketch-picker v-model="primary" />
                                </b-popover>
                            </div>
                            <div class="col-4">
                                <div class="input-group bg-white shadow-inset-2 mb-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                            Secondary
                                        </span>
                                    </div>
                                    <button id="popover-color-secondary" type="button" class="form-control pl-3" :style="{ 'background-color': (secondary || {}).hex  }"></button>
                                </div>
                                <b-popover
                                    ref="popover-color"
                                    target="popover-color-secondary"
                                    triggers="click blur"
                                    boundary="window"
                                    placement="righttop">
                                    <sketch-picker v-model="secondary" />
                                </b-popover>
                            </div>
                            <div class="col-4">
                                <div class="input-group bg-white shadow-inset-2 mb-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0" style="min-width: 100px">
                                            Tertiary
                                        </span>
                                    </div>
                                    <button id="popover-color-tertiary" type="button" class="form-control pl-3" :style="{ 'background-color': (tertiary || {}).hex  }"></button>
                                </div>
                                <b-popover
                                    ref="popover-color"
                                    target="popover-color-tertiary"
                                    triggers="click blur"
                                    boundary="window"
                                    placement="righttop">
                                    <sketch-picker v-model="tertiary" />
                                </b-popover>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-left mt-3 mb-3">
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{ $t('button_link.save') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import _ from 'lodash';
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { contactValidation } from './../../../../assets/js/dashboard/utilities'
import { Material, Compact, Swatches, Slider, Sketch, Chrome, Photoshop } from 'vue-color'
export default {
    name: 'landing',
    components: {
        // 'material-picker': Material,
        // 'compact-picker': Compact,
        // 'swatches-picker': Swatches,
        // 'slider-picker': Slider,
        'sketch-picker': Sketch,
        // 'chrome-picker': Chrome,
        // 'photoshop-picker': Photoshop
    },
    props: {
    },
    data: function () {
        return {
            info: {},

            headerTitle: '',
            headerDescription: '',

            appointmentTitle: '',
            appointmentDescription: '',

            contactShop: '',
            contactDescription: '',
            contactAddress: '',
            contactEmail: '',
            contactContact: '',

            rewardQRTitle: '',
            rewardQRBody: '',

            galleryTitle: '',
            galleryDescription: '',

            teamTitle: '',
            teamDescription: '',

            primary: '',
            secondary: '',
            tertiary: '',

            emailError: '',
            contactError: '',
        }
    },
    methods: {
        emailValidation() {
            this.emailError = this.contactEmail.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) ? '' : 'Please enter a valid email address'
        },
        contactValidation() {
            let err = contactValidation(this.contactContact)
            this.contactError = err ? this.$i18n.t('message.contact_validation.phone_number', { 'error': this.$i18n.t(`message.contact_validation.error.${err}`) }) : ''
        },

        setInfo(info) {
            this.info = info

            this.info['header'] = this.info['header'] || {}
            this.headerTitle = this.info['header']['title']
            this.headerDescription = this.info['header']['body']

            this.info['appt'] = this.info['appt'] || {}
            this.appointmentTitle = this.info['appt']['title']
            this.appointmentDescription = this.info['appt']['body']

            this.info['footer'] = this.info['footer'] || {}
            this.contactShop = this.info['footer']['title']
            this.contactDescription = this.info['footer']['body']
            this.contactAddress = this.info['footer']['address']
            this.contactEmail = this.info['footer']['email']
            this.contactContact = this.info['footer']['contact']

            this.info['rewardqr'] = this.info['rewardqr'] || {}
            this.rewardQRTitle = this.info['rewardqr']['title']
            this.rewardQRBody = this.info['rewardqr']['body']

            this.info['gallery'] = this.info['gallery'] || {}
            this.galleryTitle = this.info['gallery']['title']
            this.galleryDescription = this.info['gallery']['body']

            this.info['team'] = this.info['team'] || {}
            this.teamTitle = this.info['team']['title']
            this.teamDescription = this.info['team']['body']

            this.info['color'] = this.info['color'] || {}
            this.primary = { hex: this.info['color']['primary'] }
            this.secondary = { hex: this.info['color']['secondary'] }
            this.tertiary = { hex: this.info['color']['tertiary'] }
        },
        
        submitInfo() {
            let info = {}

            info['header'] = {}
            info['header']['title'] = this.headerTitle
            info['header']['body'] = this.headerDescription

            info['appt'] = {}
            info['appt']['title'] = this.appointmentTitle
            info['appt']['body'] = this.appointmentDescription

            info['footer'] = {}
            info['footer']['title'] = this.contactShop
            info['footer']['body'] = this.contactDescription
            info['footer']['address'] = this.contactAddress
            info['footer']['email'] = this.contactEmail
            info['footer']['contact'] = this.contactContact

            info['rewardqr'] = {}
            info['rewardqr']['title'] = this.rewardQRTitle
            info['rewardqr']['body'] = this.rewardQRBody

            info['gallery'] = {}
            info['gallery']['title'] = this.galleryTitle
            info['gallery']['body'] = this.galleryDescription

            info['team'] = {}
            info['team']['title'] = this.teamTitle
            info['team']['body'] = this.teamDescription

            info['color'] = {}
            info['color']['primary'] = (this.primary || {}).hex
            info['color']['secondary'] = (this.secondary || {}).hex
            info['color']['tertiary'] = (this.tertiary || {}).hex

            this.$emit('submitInfo', info);
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>